import cn from 'classnames';
import React from 'react';
import {twMerge} from 'tailwind-merge';

import appConfig from '../../config/appConfig';
import * as localizationKeys from '../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../services/localization/localizationService';
import Article from '../DataDisplay/Article';
import HelpBlueIcon from '../Icons/HelpBlueIcon';
import LocationBlueIcon from '../Icons/LocationBlueIcon';
import {ContentWrapper} from '../Layout';

const SupportAndStoreTemplate = (props) => {
    const {className, isTitleVisible} = props;
    const localizedStrings = getLocalizedStrings();
    const supportUrl = appConfig.getDcsSupportUrlFormatted();
    const storeUrl = appConfig.getIqosStoreUrlFormatted();
    const supportTitle = localizationKeys.SUPPORT_CONTACT_US_TITLE_TEXT;
    const storeTitle = localizationKeys.SUPPORT_FIND_STORE_TITLE_TEXT;
    const supportButtonText = localizationKeys.SUPPORT_CONTACT_US_BUTTON_TEXT;
    const storeButtonText = localizationKeys.SUPPORT_FIND_STORE_BUTTON_TEXT;
    const isSupportTitleVisible = supportUrl || storeUrl;

    return (
        <div className='w-full'>
            <ContentWrapper>
                {isSupportTitleVisible && isTitleVisible && (
                    <h2 className='mb-10 mt-10 text-24 md:mt-16'>
                        {localizedStrings[localizationKeys.SUPPORT_OTHER_WAYS_TITLE_TEXT]}
                    </h2>
                )}
                <div
                    className={twMerge(
                        cn(
                            'flex w-full flex-col items-center gap-10 md:w-auto lg:flex-row lg:gap-6',
                            {'mt-[60px]': !isSupportTitleVisible || !isTitleVisible},
                            className
                        )
                    )}
                >
                    {supportUrl && (
                        <Section
                            icon={<HelpBlueIcon />}
                            titleKey={supportTitle}
                            buttonTo={supportUrl}
                            buttonTextKey={supportButtonText}
                        />
                    )}
                    {storeUrl && (
                        <Section
                            icon={<LocationBlueIcon />}
                            titleKey={storeTitle}
                            buttonTo={storeUrl}
                            buttonTextKey={storeButtonText}
                        />
                    )}
                </div>
            </ContentWrapper>
        </div>
    );
};

const Section = (props) => {
    const {icon, titleKey, buttonTo, buttonTextKey} = props;

    return (
        <Article
            icon={icon}
            className='w-full md:self-stretch'
            titleClassName='text-18 mt-3 md:mt-4 flex-1'
            titleKey={titleKey}
            buttonSecondary={{
                isTargetBlank: true,
                isExternalLink: true,
                to: buttonTo,
                className: 'mt-6 sm:min-w-[312px]',
                textKey: buttonTextKey,
            }}
        />
    );
};

export default SupportAndStoreTemplate;
